import PageContainer from "../components/CommonComponents/PageContainer/PageContainer";
import UserCard from "../components/UserComponents/UserCard";
import UserTable from "../components/UserComponents/UserTable";
import React, {useEffect, useState} from "react";
import {Organization, User, UserRole} from "../types/users";
import {changePassword, updateUser} from "../queries/userQueries";
import ErrorSnackBar from "../components/CommonComponents/ErrorSnackBar/ErrorSnackBar";
import RoleRendering from "../guards/RoleRendering";
import OrganizationTable from "../components/UserComponents/OrganizationTable";
import Box from "@mui/material/Box";
import {useTheme} from "../contexts/theme";
import SocialCardContainer from "../components/UserComponents/SocialCardContainer";
import SocialAccountSection from "../components/UserComponents/SocialAccounts/SocialAccountSection";
import {EntityType} from "../utils/constants";
import {useAuth} from "../contexts/auth";

export default function UserPage(){

    const theme = useTheme()

    const auth = useAuth()


    const [updatedEntity, setUpdatedEntity] = useState<EntityType.users | EntityType.organizations | "">("")

    const [errorMessage, setErrorMessage] = useState<{error: boolean, message: string}>({
        error:false,
        message: "",
    })

    const handleSetErrorMessage = (error: boolean, message: string): void => {
        setErrorMessage({
            error: error,
            message: message
        })
    }

    const handeChangeUser = (user: User, userId: string) => {
        updateUser(user, userId).then(response => {
            setErrorMessage({error: true, message: "Information Changed"});
            auth.updateLocalStorageUser(user)
        })
    }

    const handleChangePassword = (userId: string) => {
        changePassword(userId).then(response => {
            setErrorMessage({error: true, message: "An email has been sent to change your password."});
        })
    }

    const handleUpdateEntity = (value: EntityType.users | EntityType.organizations | "") => {
        setUpdatedEntity(value)
    }

    useEffect(() => {
    },[updatedEntity])

    return(
        <PageContainer>
            <ErrorSnackBar  autoHideDuration={2000} open={errorMessage.error} setClose={()=>{setErrorMessage({
                error: false,
                message: ""
            })}} errorMessage={errorMessage.message} />
            <Box style={{
                width: "100%",
                height: "100%",
                overflowY: "auto",
                backgroundColor: theme.palette.blue,
            }}>
                <UserCard changeUserInformation={handeChangeUser} changePassword={handleChangePassword}/>
                <SocialAccountSection handleErrorMessage={handleSetErrorMessage} />
                <RoleRendering roles={[UserRole.Admin, UserRole.SuperAdmin]}><UserTable updateEntity={updatedEntity} handleUpdateEntity={handleUpdateEntity}/></RoleRendering>
                <RoleRendering roles={[UserRole.SuperAdmin]}>
                    <Box marginTop={theme.spacing.lg}>
                        <OrganizationTable updateEntity={updatedEntity} handleUpdateEntity={handleUpdateEntity}/>
                    </Box>
                </RoleRendering>
            </Box>
        </PageContainer>
    )
}